import { useEmailContext } from '../../../../contexts/EmailContext';
import EmailTab from './EmailTab';
import CreateOutboundEmailButton from './Outbound/CreateOutboundEmailButton';
import { Box } from '@coolblue-development/freddy';

const EmailSidePanel = (): JSX.Element => {
  const { emailContacts } = useEmailContext();

  return (
    <Box>
      <CreateOutboundEmailButton />
      {emailContacts.map(contactId => (
        <EmailTab key={contactId} contactId={contactId} />
      ))}
    </Box>
  );
};

export default EmailSidePanel;
